// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Bry6h","success":"styles_success__T7nRz","error":"styles_error__TY8Ga"};